import React from 'react';

import getCommonStack, { CommonStackParamList } from '@navigation/CommonStack';
import { GroupRoute } from '@navigation/Routes';
import { createStackNavigator } from '@react-navigation/stack';
import ViewGroupsScreen from '@screens/Group/List';

export type GroupScreenType = 'tab' | 'onboarding';

export type GroupStackParamList = {
  [GroupRoute.ViewGroups]: {
    screenType?: GroupScreenType;
  };
} & CommonStackParamList;

const GroupStackNavigator = createStackNavigator<GroupStackParamList>();

export default function GroupStack() {
  return (
    <GroupStackNavigator.Navigator
      id={undefined}
      initialRouteName={GroupRoute.ViewGroups}
      screenOptions={{
        headerShown: true,
        headerBackButtonDisplayMode: 'generic',
      }}>
      <GroupStackNavigator.Screen
        name={GroupRoute.ViewGroups}
        component={ViewGroupsScreen}
        initialParams={{ screenType: 'tab' }}
        options={{ title: 'Groups' }}
      />
      {getCommonStack(GroupStackNavigator)}
    </GroupStackNavigator.Navigator>
  );
}
